module.exports = __webpack_public_path__ + "img/special-img-4.38347db9.svg";